import React from 'react';
import { motion } from 'framer-motion';
const phraseVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: 'easeOut'
    }
  }
};
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1.2
    }
  }
};
export function SignalSection() {
  return <section className="bg-gradient-section px-5 pb-20 pt-20 md:px-8 md:pb-24 md:pt-24" style={{
    paddingBottom: '0px'
  }} data-id="element-754" data-mp="39olrnwdild0m">
      <div className="mx-auto max-w-2xl" data-id="element-755" data-mp="3dqguj5b3fygi">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.4
      }} className="text-left md:text-center" data-id="element-756" data-mp="3dpfk931wjfzu">
          {/* LCP: protagonista estático en el primer render. La animación queda en los elementos posteriores. */}
          <h2 className="font-display font-bold leading-[1.02] tracking-tight text-[#F0E8D8]" style={{
          fontSize: 'clamp(42px, 12vw, 64px)',
          marginBottom: 'clamp(24px, 4vw, 32px)'
        }} data-id="element-757" data-mp="3slelpuuiahw0">
            Tu cuerpo
            <br data-id="element-758" data-mp="19b9wdw9dr43o" />
            no falló.
          </h2>

          <motion.p variants={phraseVariants} className="font-display italic leading-[1.08] text-[#C8A870]" style={{
          fontSize: 'clamp(26px, 6vw, 48px)',
          marginBottom: '0.25em'
        }} data-id="element-759" data-mp="19curbmzlwp22">
            Cambió la señal.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: 0.35,
          delay: 0.45
        }} className="mx-auto mb-14 flex w-full justify-center md:mb-16" aria-hidden="true" data-id="element-760" data-mp="1wzt5ge097kwt">
            <svg viewBox="0 0 240 32" className="h-auto w-[72%] max-w-[240px] overflow-visible" fill="none" data-id="element-761" data-mp="212pjdreumsuf">
              <motion.path d="M6 17 C14 7 23 25 32 16 C41 7 50 24 60 15 C70 7 79 22 89 15 C99 9 108 19 119 16 C130 14 140 17 151 16 L210 16" stroke="#C8A870" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" initial={{
              pathLength: 0,
              opacity: 0
            }} whileInView={{
              pathLength: 1,
              opacity: 0.9
            }} viewport={{
              once: true,
              amount: 0.6
            }} transition={{
              pathLength: {
                duration: 1.1,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.5
              },
              opacity: {
                duration: 0.25,
                delay: 0.5
              }
            }} data-id="element-762" data-mp="bpc79g0hw0ir" />

              <motion.circle cx="216" cy="16" r="2.8" fill="#C8A870" initial={{
              opacity: 0,
              scale: 0.5
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.6
            }} transition={{
              delay: 1.45,
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} style={{
              transformOrigin: '216px 16px'
            }} data-id="element-763" data-mp="2zejxc07n18z3" />
            </svg>
          </motion.div>

          <motion.p variants={phraseVariants} className="font-display text-[#C8A870]/70 mt-4 md:mt-6" style={{
          fontSize: '21px'
        }} data-id="element-764" data-mp="wqv3zkjlwiq7">
            Lo que antes funcionaba,
            <br data-id="element-765" data-mp="nt1il4ndr9ht" />
            ya no responde igual.
          </motion.p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.35
      }} className="mx-auto max-w-xl text-center" style={{
        marginTop: 'clamp(28px, 4vw, 40px)'
      }} data-id="element-766" data-mp="1kgxuhw7vhgmp">
          <p className="font-display text-[#F0E8D8]/75" style={{
          fontSize: 'clamp(19px, 4.2vw, 26px)',
          lineHeight: 1.45,
          marginBottom: 'clamp(22px, 4vw, 32px)'
        }} data-id="element-767" data-mp="16ornazmp6jze">
            No es cuestión de exigirte más.
          </p>

          <p className="font-display text-[#F0E8D8]/75" style={{
          fontSize: 'clamp(19px, 4.2vw, 26px)',
          lineHeight: 1.45,
          marginBottom: 'clamp(28px, 5vw, 40px)'
        }} data-id="element-768" data-mp="1iyz6g1oz32ce">
            Es aprender a acompañar
            <br data-id="element-769" data-mp="1a1f22jvtcpxk" />
            este momento.
          </p>

          <p className="font-display font-semibold text-[#F0E8D8]" style={{
          fontSize: 'clamp(20px, 4.5vw, 28px)',
          lineHeight: 1.35,
          marginBottom: 'clamp(18px, 3vw, 26px)'
        }} data-id="element-770" data-mp="1eyyfjhkosyog">
            No necesitás hacer más.
          </p>

          <p className="font-display italic text-[#C8A870]/85" style={{
          fontSize: 'clamp(18px, 4vw, 24px)',
          lineHeight: 1.4
        }} data-id="element-771" data-mp="1sy6fwdsl6cu8">
            Necesitás entender qué necesita
            <br data-id="element-772" data-mp="2lmvjqkl10w9o" />
            tu cuerpo hoy.
          </p>
        </motion.div>

        
      </div>
    </section>;
}